import { BindersAction } from "./actions";
import { BinderItem, BinderActionSet } from "models/BinderItem";
import { Reducer } from "redux";
import produce from "immer";

export interface BindersState {
  openFlg: boolean;
  home: BinderItem[];
  personal: BinderItem[];
  nikkei: BinderItem[];
  binderAction: BinderActionSet | null;
  isLoading: boolean;
  loadingCount: number;
  personalTotalCount: number;
  nikkeiTotalCount: number;
  isAdding: boolean;
  nikkeiOffset: number;
  nikkeiLimit: number;
  nikkeiListLimit: number;
  nikkeiSortValue: string;
  nikkeiKeyword: string;
  nikkeiSearchedKeyword: string;
  personalOffset: number;
  personalLimit: number;
  personalListLimit: number;
  personalSortValue: string;
  personalKeyword: string;
  personalSearchedKeyword: string;
  isSearch: boolean;
}

const initialState: BindersState = {
  openFlg: false,
  home: [],
  personal: [],
  nikkei: [],
  binderAction: null,
  isLoading: false,
  loadingCount: 0,
  personalTotalCount: 0,
  nikkeiTotalCount: 0,
  isAdding: false,
  nikkeiOffset: 0,
  nikkeiLimit: 20,
  nikkeiListLimit: 20,
  nikkeiSortValue: "1",
  nikkeiKeyword: "",
  nikkeiSearchedKeyword: "",
  personalOffset: 0,
  personalLimit: 20,
  personalListLimit: 20,
  personalSortValue: "1",
  personalKeyword: "",
  personalSearchedKeyword: "",
  isSearch: false
};

export const bindersList: Reducer<BindersState, BindersAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "binders/list/SET_HOME_BINDER_ITEMS":
      return produce(state, draft => {
        draft.home = action.payload.binderItems;
      });
    case "binders/list/SET_PERSONAL_BINDER_ITEMS":
      return produce(state, draft => {
        draft.personal = action.payload.binderItems;
      });
    case "binders/list/ADD_PERSONAL_BINDER_ITEMS":
      return produce(state, draft => {
        draft.personal = draft.personal.concat(action.payload.binderItems);
      });
    case "binders/list/ADD_NIKKEI_BINDER_ITEMS":
      return produce(state, draft => {
        draft.nikkei = draft.nikkei.concat(action.payload.binderItems);
      });
    case "binders/list/REMOVE_PERSONAL_BINDER_ITEMS":
      return produce(state, draft => {
        draft.personal = [];
      });
    case "binders/list/SET_NIKKEI_BINDER_ITEMS":
      return produce(state, draft => {
        draft.nikkei = action.payload.binderItems;
      });
    case "binders/list/SET_BINDER_ACTION_VALUE":
      return produce(state, draft => {
        draft.binderAction = action.payload.binderActionValue;
      });
    case "binders/list/RESET_BINDER_ACTION_VALUE":
      return produce(state, draft => {
        draft.binderAction = initialState.binderAction;
      });
    case "binders/list/SET_BINDER_OPEN_FLG_VALUE":
      return produce(state, draft => {
        draft.openFlg = action.payload.isBinderOpenFlg;
      });
    case "binders/list/CHANGE_ISLOADING":
      return produce(state, draft => {
        draft.loadingCount = action.payload.isLoadingFlg
          ? state.loadingCount + 1
          : state.loadingCount - 1;

        draft.isLoading = draft.loadingCount >= 1;
      });
    case "binders/list/SET_PERSONAL_TOTAL_COUNT":
      return produce(state, draft => {
        draft.personalTotalCount = action.payload.totalCount;
      });
    case "binders/list/SET_NIKKEI_TOTAL_COUNT":
      return produce(state, draft => {
        draft.nikkeiTotalCount = action.payload.totalCount;
      });
    case "binders/list/CHANGE_ISADDING":
      return produce(state, draft => {
        draft.isAdding = action.payload.isAdding;
      });
    case "binders/list/SET_NIKKEI_OFFSET":
      return produce(state, draft => {
        draft.nikkeiOffset = action.payload.nikkeiOffset;
      });
    case "binders/list/SET_NIKKEI_LIMIT":
      return produce(state, draft => {
        draft.nikkeiLimit = action.payload.nikkeiLimit;
      });
    case "binders/list/SET_NIKKEI_LIST_LIMIT":
      return produce(state, draft => {
        draft.nikkeiListLimit = action.payload.nikkeiListLimit;
      });
    case "binders/list/SET_NIKKEI_SORT_VALUE":
      return produce(state, draft => {
        draft.nikkeiSortValue = action.payload.nikkeiSortValue;
      });
    case "binders/list/SET_NIKKEI_KEYWORD":
      return produce(state, draft => {
        draft.nikkeiKeyword = action.payload.nikkeiKeyword;
      });
    case "binders/list/SET_NIKKEI_SEARCHED_KEYWORD":
      return produce(state, draft => {
        draft.nikkeiSearchedKeyword = action.payload.nikkeiSearchedKeyword;
      });
    case "binders/list/SET_PERSONAL_OFFSET":
      return produce(state, draft => {
        draft.personalOffset = action.payload.personalOffset;
      });
    case "binders/list/SET_PERSONAL_LIMIT":
      return produce(state, draft => {
        draft.personalLimit = action.payload.personalLimit;
      });
    case "binders/list/SET_PERSONAL_LIST_LIMIT":
      return produce(state, draft => {
        draft.personalListLimit = action.payload.personalListLimit;
      });
    case "binders/list/SET_PERSONAL_SORT_VALUE":
      return produce(state, draft => {
        draft.personalSortValue = action.payload.personalSortValue;
      });
    case "binders/list/SET_PERSONAL_KEYWORD":
      return produce(state, draft => {
        draft.personalKeyword = action.payload.personalKeyword;
      });
    case "binders/list/SET_PERSONAL_SEARCHED_KEYWORD":
      return produce(state, draft => {
        draft.personalSearchedKeyword = action.payload.personalSearchedKeyword;
      });
    case "binders/list/SET_IS_SEARCH":
      return produce(state, draft => {
        draft.isSearch = action.payload.isSearch;
      });
    default:
      return state;
  }
};
